import { render } from "./TambahPelarasanDialog.vue?vue&type=template&id=1e603450"
import script from "./TambahPelarasanDialog.vue?vue&type=script&lang=js"
export * from "./TambahPelarasanDialog.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__